/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "city-plantsoen",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:4c30e1e8-8a3e-4dc7-a5cc-b55ada8aade6",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_jD7JW5Siw",
    "aws_user_pools_web_client_id": "1a5a08vq4uf2tff235fgq1fpi2",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "plantsoenApi",
            "endpoint": "https://mp132jquf9.execute-api.eu-west-1.amazonaws.com/plantsoen",
            "region": "eu-west-1"
        }
    ]
};


export default awsmobile;
